<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>
<script>
import { Bar } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "StackedChart",
  components: {
    Bar,
  },
  props: {
    data: {
      type: Array,
    },
    yTitle :{
      type: String,
    },
    labels: {
      type: Array,
    },
    label: {
      type: String,
    },
    backgroundColor: {
      type: Array,
    },
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 10,
    },
    height: {
      type: Number,
      default: 250,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      // default: () => [],
      default: () => [ChartDataLabels],
    },
  },
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: [
          {
            label: this.label,
            backgroundColor: this.backgroundColor,
            data: this.data,
            barPercentage: 0.4,
            datalabels: {
              anchor: "end",
              align: 'top',
              color: "#219fd4",
              font: {
                size: 15,
              },
            },
          },
        ],
      },
      chartOptions: {
        scales: {
              y: {
                title: {
                  display: true,
                  text: this.yTitle
                }
              },
            },
        responsive: true,
        maintainAspectRatio: false,
         layout: {
                    padding: {
                        left: 10,
                        right: 10,
                        top: 30,
                        bottom: 10
                    }
                    },
        plugins: {
          legend: {
         display: false
        },
          datalabels: {
            formatter: function (value, context) {
              return new Intl.NumberFormat("en-US").format(value[1] - value[0]);
            },
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const v = context.dataset.data[context.parsed.x];
                let label = context.label || "";
                if (label) {
                  label += ": ";
                }
                if (context.parsed.y !== null) {
                  label += new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "INR",
                  }).format(v[1] - v[0]);
                }
                return  label;
              },
              title: function (context) {
                let title = context[0].dataset.label
                return title
              }

            },
          },
        },
      },
    };
  },
};
</script>
